import cn from 'clsx';

const circleCn = 'h-2.5 w-2.5 bg-black bg-opacity-40 rounded-full';
const Spinner: React.FC<{className?: string}> = ({ className }) => {
  return (
    <div className="flex">
      <div className={cn(circleCn, 'mr-1 animate-bounce', className)}></div>
      <div className={cn(circleCn, 'mr-1 animate-bounce-200', className)}></div>
      <div className={cn(circleCn, 'animate-bounce-400', className)}></div>
    </div>
  );
};

interface LoaderProps {
  title?: string;
  description?: string;
  spinnerCn?: string;
}

const Loader: React.FC<LoaderProps> = ({
  title = 'Loading...',
  description,
  spinnerCn
}) => {
  return (
    <div className="flex flex-col items-center p- ">
      <div className="w-12 mb-4 ">
        <Spinner className={spinnerCn} />
      </div>
      <h2 className="mb-2 text-center">{title}</h2>
      {description && <p className="text-sm text-center">{description}</p>}
    </div>
  );
};

export default Loader;
